import React from 'react'
import Landscape from './Landscape'
import Footer from '../Home/Footer'
import { useAnchorAutoScroll } from '../../utils/Utils'

const BeAViewer = () => {
  useAnchorAutoScroll()
  return (
    <div>
      <Landscape />
      <Footer />
    </div>
  )
}

export default BeAViewer
